"use client";
import React from "react";
import Footer from "../components/Footer";
import Serve from "../components/industries/Serve";
import TrustEmpayer from "../components/industries/TrustEmpayer";
import HeadingWithChips from "../components/common/HeadingWithChips";
import randomGraphic from '../assets/random-graphic.png';
import expertiseIcon from '../assets/expertise.png'
import FirstSection from "../components/common/FirstSection";
const Industries: React.FC = () => {
  return (
        <main>
        <FirstSection 
        icon={expertiseIcon}
        iconAlt="Suite icon"
        backgroundImage={randomGraphic}
        title="Expertise across <br/> diverse sectors"
        buttonHref="/contact?type=company"
        description={
            <>
            We offer secure, practical <br/>
                payment solutions tailored <br/>
                to your unique needs
            </>
        }
        buttonText="CONTACT US"
        buttonVariant="lightPurple"
        heading="EPAYR <br/> for your industry"
        leftColumnSx={{
            backgroundColor: "beige.200"
        }}
        />
        <Serve/>
        <TrustEmpayer/>
        <HeadingWithChips 
          headingPrefix="You can "
          headingHighlight="count"
          headingSuffix=" on us"
          headingVariant="subtitle12"
          subheading='NO MATTER YOUR INDUSTRY, SMOOTH<br/>AND SECURE PAYMENTS ARE ESSENTIAL.'
          discussionText={["LET'S ", " THE BEST PAYMENT STRATEGY FOR ", ""]}
          chips = {[
            { text: "DISCUSS", backgroundColor: "lightPurple.200", textColor: "lightPurple.500" },
            { text: "YOUR BUSINESS",  backgroundColor: "beige.200",  textColor: "beige.700" }
          ]}
          displayIcons={false}
        />
        <Footer 
              buttonText="CONTACT US" 
              buttonLink="/contact?type=company"
              ctaText={{
                prefix: 'PAYMENTS SHOULD WORK FOR YOU - <br/>',
                highlight1: ' NOT SLOW ',
                middle: 'YOU DOWN',
                highlight2: '',
                suffix: ''
              }}
            />
        </main>
  );
};

export default Industries;
